import { ApiError } from './apiClient.tsx';
import { strings } from './strings.tsx';

/**
 * 서버 오류를 화면에 그대로 보여줄 문자열로 만든다.
 *
 * 무인 운행 플랫폼에서 '저장한 줄 알았는데 아니었다'가 가장 나쁘다. 특히
 * 안전장치 화면(비용 상한·킬스위치)에서 실패를 삼키면 운영자는 한도가 걸린
 * 줄 알고 지나간다. 서버는 결정35 이후 그래프 오류를 한국어 message 로
 * 돌려주므로 그 문구는 번역하지 않고 그대로 노출한다(콘솔은 src/api를 고칠 수
 * 없음, 지시21) — 대신 `code`(계약의 validation_error·unauthorized·not_found 등)만
 * 콘솔이 소유한 영문 라벨로 앞에 붙인다. 모르는 code도 사람이 읽을 수 있게
 * humanize하고, code 자체가 없는 오류는 원문 message를 그대로 둔다 — 유일한
 * 진단 단서를 버리지 않기 위함.
 */
function humanizeCode(code: string): string {
  return code.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function describeError(error: unknown): string {
  if (error instanceof ApiError) {
    if (!error.code) return error.message;
    const label = strings.errors.codeLabels[error.code] ?? humanizeCode(error.code);
    return `${label}: ${error.message}`;
  }
  if (error instanceof Error) return error.message;
  return String(error);
}
